import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function ClosingSection() {
  return <section className="py-20 px-4 bg-gradient-to-b from-[#111] to-[#0a0a0a] border-t border-gray-800" data-id="element-49">
      <div className="max-w-4xl mx-auto text-center" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-51">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 px-5 py-2.5 rounded-full font-bold mb-8 border border-red-500/20 tracking-wide" data-id="element-52">
            🚨 DECISIÓN
          </div>

          <h2 className="text-4xl md:text-5xl font-black mb-12 leading-tight" data-id="element-53">
            Podés seguir como estás…
          </h2>

          <div className="space-y-6 mb-12" data-id="element-54">
            <p className="text-2xl md:text-3xl text-gray-500 font-bold" data-id="element-55">
              Mirando.
            </p>
            <p className="text-2xl md:text-3xl text-gray-500 font-bold" data-id="element-56">
              Dudando.
            </p>
            <p className="text-2xl md:text-3xl text-gray-500 font-bold" data-id="element-57">
              Postergando.
            </p>
          </div>

          <div className="bg-gradient-to-r from-brand-yellow/20 to-brand-gold/20 border-2 border-brand-yellow py-8 px-6 rounded-3xl mb-12" data-id="element-58">
            <p className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-59">
              O podés hacer algo{' '}
              <span className="text-brand-yellow" data-id="element-60">distinto hoy.</span>
            </p>
          </div>

          <div className="mb-16" data-id="element-61">
            <h3 className="text-3xl md:text-4xl font-black mb-8 flex items-center justify-center gap-3" data-id="element-62">
              <span className="text-4xl" data-id="element-63">🎯</span> EMPEZÁ HOY CON RENOVA DETAIL
            </h3>
            <p className="text-2xl md:text-3xl text-gray-300 mb-10 font-bold" data-id="element-64">
              Accedé ahora a la formación completa
              <br data-id="element-65" />
              <span className="text-brand-yellow" data-id="element-66">+ los 5 bonos incluidos</span>
            </p>
            <Button data-id="element-67">QUIERO MI FORMACIÓN + 5 BONOS GRATIS</Button>
          </div>

          <div className="bg-black border border-gray-800 rounded-3xl p-10" data-id="element-68">
            <p className="text-3xl md:text-4xl font-black mb-4" data-id="element-69">
              💥 No se trata de autos.
            </p>
            <p className="text-2xl md:text-3xl text-gray-400 font-bold" data-id="element-70">
              Se trata de dejar de estar en el mismo lugar.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}